import { object, array, string } from "yup";

export default object()
  .required()
  .shape({
    links: array().of(object())
  });
